export default [
  { id: 179, value: 300 },
  { id: 177, value: 600 },
  { id: 180, value: 900 },
];
